/*=====================================
    RootSwitchView

    Author: Gray
    createtime: 2017 / 12 / 21
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import CupoyRouter from "components/commons/router/CupoyRouter";
import HomeView from 'components/HomeView';

/*--------------------------
    Style Component
--------------------------*/

/*--------------------------
    Variables
--------------------------*/

/*--------------------------
    Main Component
--------------------------*/
class CupoyRouterSwitchView extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {
        super(props);

        this.previousLocation = undefined;
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount () {

    }

    // ------------------------------
    // componentWillUpdate
    // ------------------------------
    componentWillUpdate(nextProps) {

        const { location } = this.props
        // set previousLocation if props.location is not modal
        if (nextProps.history.action !== 'POP' && (!location.state || !location.state.modal)) {
            this.previousLocation = this.props.location;
        }
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { location } = this.props;
        const isModal = !!(location.state && location.state.modal && this.previousLocation && this.previousLocation !== location); // not initial render

        return (
            <div className="full-height">
                <Switch location={isModal ? this.previousLocation : location}>
                    <Route path={CupoyRouter.PATHS.HOME} component={HomeView}/>
                </Switch>
            </div>
        );
    }
}

export default CupoyRouterSwitchView;



// WEBPACK FOOTER //
// ./src/components/commons/router/CupoyRouterSwitchView.jsx